// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@conklin/XDL/types";

export default {
    primary: {
        main: "#B2292E",
        contrast: "#FFFFFF",
    },
    secondary: {
        main: "#000000",
        contrast: "#FFFFFF",
    },
    common: {
        background: "#FFFFFF",
        backgroundContrast: "#2E2E2E",
        accent: "#F8F9FA",
        accentContrast: "#2E2E2E",
        border: "#CCCCCC",
        disabled: "#CCCCCC",
        white: "#FFFFFF",
        black: "#000000",
        ui1: "#FFFFFF",
        ui2: "#EEEEEE",
        ui3: "#CCCCCC",
        ui4: "#999999",
        ui5: "#666666",
        ui6: "#2E2E2E",
        ui7: "#000000",
        ui8: "#F5F4F2",
        ui9: "#1E3160",
        ui10: "#2E4C98",
        ui11: "#111C39",
    },
    text: {
        main: "#2E2E2E",
        disabled: "#475353",
        accent: "#2D3435",
        link: "#1E3160",
    },
    success: {
        main: "#00A65A",
        light: "#D9F2E7",
        contrast: "#FFFFFF",
    },
    danger: {
        main: "#E4104E",
        light: "#FBDBE5",
        contrast: "#FFFFFF",
    },
    warning: {
        main: "#DAA91C",
        light: "#FDF9DE",
        contrast: "#FFFFFF",
    },
    info: {
        main: "#53ACDB",
        light: "#DDEEF8",
        contrast: "#FFFFFF",
    },
} as xBaseTheme["colors"];
